/**
 * @generated SignedSource<<a92643672c1c7793242060951aa167ad>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TransformWandApplyInputObject = {
  anchorAmountCents: number;
  anchorDate: string;
  anchorDescription?: string | null | undefined;
  anchorMd5?: string | null | undefined;
  label?: string | null | undefined;
  method: string;
  stakeholderId: string;
  window: string;
};
export type stakeholderDetailPage_TransformWandApplyMutation$variables = {
  input: TransformWandApplyInputObject;
};
export type stakeholderDetailPage_TransformWandApplyMutation$data = {
  readonly transformWandApply: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly stakeholder: {
      readonly id: string;
      readonly transformChain: {
        readonly enabled: boolean;
        readonly steps: ReadonlyArray<{
          readonly anchorJson: string | null | undefined;
          readonly kind: string;
          readonly ordinal: number;
          readonly paramsJson: string;
        }>;
      };
    } | null | undefined;
  } | null | undefined;
};
export type stakeholderDetailPage_TransformWandApplyMutation = {
  response: stakeholderDetailPage_TransformWandApplyMutation$data;
  variables: stakeholderDetailPage_TransformWandApplyMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "enabled",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ordinal",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "paramsJson",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "anchorJson",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "stakeholderDetailPage_TransformWandApplyMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TransformWandApplyMutationPayload",
        "kind": "LinkedField",
        "name": "transformWandApply",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Stakeholder",
            "kind": "LinkedField",
            "name": "stakeholder",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TransformChain",
                "kind": "LinkedField",
                "name": "transformChain",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TransformStep",
                    "kind": "LinkedField",
                    "name": "steps",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v8/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "stakeholderDetailPage_TransformWandApplyMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TransformWandApplyMutationPayload",
        "kind": "LinkedField",
        "name": "transformWandApply",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Stakeholder",
            "kind": "LinkedField",
            "name": "stakeholder",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TransformChain",
                "kind": "LinkedField",
                "name": "transformChain",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TransformStep",
                    "kind": "LinkedField",
                    "name": "steps",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v8/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3ff403ce4f00071579f26fae575dc907",
    "id": null,
    "metadata": {},
    "name": "stakeholderDetailPage_TransformWandApplyMutation",
    "operationKind": "mutation",
    "text": "mutation stakeholderDetailPage_TransformWandApplyMutation(\n  $input: TransformWandApplyInputObject!\n) {\n  transformWandApply(input: $input) {\n    stakeholder {\n      id\n      transformChain {\n        enabled\n        steps {\n          ordinal\n          kind\n          paramsJson\n          anchorJson\n          id\n        }\n        id\n      }\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0405d87182db4d4b91a17a0c0ea7e358";

export default node;
